import { get } from "lodash";

export const getDeepValue = <T extends Record<string, unknown>>(obj: T, path: string): ReturnType<typeof get> =>
    get(obj, path);
